var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reference-line"},_vm._l((_vm.lines),function(item,i){return _c('div',{key:i,staticClass:"line",style:({
      left: ((item.left) + "px"),
      top: ((item.top) + "px"),
      width: item.left === 0 ? '100%' : 'auto',
      height: item.top === 0 ? '100%' : 'auto'
    })})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3609b338","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/HotSpot/components/ReferenceLine.vue
// module id = null
// module chunks = 